module.exports = __webpack_public_path__ + "img/icon_switch.519950b5.svg";